/**
 * Monotonic chat message ids (2026-09-25 gap closure).
 *
 * Ids are React keys and are matched by equality (e.g. the user bubble added
 * before a location prompt). `Date.now()` alone repeats within a millisecond,
 * so two messages from one event burst shared a key. Ids stay numeric and
 * never fall below the wall clock, so they sort after ids persisted by an
 * earlier page load.
 */
let lastId = 0;

/** @returns {number} an id strictly greater than every id returned before. */
export function nextMessageId() {
  const now = Date.now();
  lastId = now > lastId ? now : lastId + 1;
  return lastId;
}
